// extracted by mini-css-extract-plugin
export default {"main":"Stack_main__MoWsD","card":"Stack_card__1pvmn","spin":"Stack_spin__9HAG9"};